import avatar_2 from '@/images/avatar_2.png';
import icon_pen from '@/images/icon_pen.png';
import icon_people from '@/images/icon_people.png';
import icon_folder from '@/images/icon_folder.png';
import icon_paper from '@/images/icon_paper.png';
import icon_square from '@/images/icon_square.png';
import icon_camera from '@/images/icon_camera.png';
import icon_time from '@/images/icon_time.png';
import icon_message from '@/images/icon_message.png';
import icon_transcription from '@/images/icon_transcription.png';
import icon_calendar from '@/images/icon_calendar.png';
import icon_arrow from '@/images/icon_arrow.png';
import icon_star from '@/images/icon_star.png';
import icon_plan from '@/images/icon_plan.png';
import icon_generate from '@/images/icon_generate.png';
import icon_data from '@/images/icon_data.png';
import icon_history from '@/images/icon_history.png';
import icon_psico from '@/images/icon_psico.png';
import icon_treatment from '@/images/icon_treatment.png';
import muy_agradable from '@/images/muy_agradable.png';
import agradable from '@/images/agradable.png';
import muy_bien from '@/images/muy_bien.png';
import bien from '@/images/bien.png';
import regular from '@/images/regular.png';
import mal from '@/images/mal.png';
import triste from '@/images/triste.png';
export const IconFolder = icon_folder;
export const AVATAR_DEFAULT =
  'https://thumbs.dreamstime.com/b/default-avatar-profile-trendy-style-social-media-user-icon-187599373.jpg';

export const SUSBCRIPTION_METHODS = [
  {
    value: 'monthly',
    title: 'Mensual (€## al mes)',
    description: 'Pago €### por año',
  },
  {
    value: 'yearly',
    title: 'Anual (€## al año)',
    description: '',
  },
];

export const PAYMENT_METHODS_ENUM = {
  CARDS: 'credit_debit_card',
};

export const PAYMENT_METHODS = [
  {
    value: PAYMENT_METHODS_ENUM.CARDS,
    title: 'Tarjeta de credito o debito',
    description: 'Visa, Mastercard, American Express',
  },
];

export const INVOICE_ITEMS_MOCK = [
  {
    title: 'Plan profesional',
    description: '30 Pacientes',
    info: 'Anual',
    amount: 256.0,
  },
  {
    title: 'Plan basico',
    description: '10 Pacientes',
    info: 'Anual',
    amount: 149.0,
  },
];

export const PATIENTS_MOCK = [
  {
    id: '22857',
    name: 'Benton Wyness',
    age: '61',
    avatar: '/images/avatar_2.png',
  },
  {
    id: '17684',
    name: 'Layla Petraitis',
    age: '83',
    avatar: '/images/avatar_3.png',
  },
  {
    id: '87281',
    name: 'Mahala Shippey',
    age: '86',
    avatar: '/images/avatar_2.png',
  },
  {
    id: '36747',
    name: 'Marla Preator',
    age: '97',
    avatar: '/images/avatar_3.png',
  },
  {
    id: '19272',
    name: 'Robert Whitrod',
    age: '28',
    avatar: '/images/avatar_2.png',
  },
  {
    id: '54797',
    name: 'Cleveland Cowthard',
    age: '78',
    avatar: '/images/avatar_3.png',
  },
  {
    id: '36041',
    name: 'Murielle Crippin',
    age: '70',
    avatar: '/images/avatar_2.png',
  },
  {
    id: '86236',
    name: 'Gerri Griffitts',
    age: '65',
    avatar: '/images/avatar_3.png',
  },
  {
    id: '49745',
    name: 'Roz Stearley',
    age: '28',
    avatar: '/images/avatar_2.png',
  },
  {
    id: '07045',
    name: 'Antonino Kohler',
    age: '96',
    avatar: '/images/avatar_3.png',
  },
];

export const SPECIALTIES_MOCK = [
  'Psicología Integradora',
  'Terapia Cognitivo Conductual',
  'Psicoterapia Psicodinámica',
  'Terapia Humanista',
  'Terapia Conductual',
  'Terapia Sistémica',
  'Terapia Interpersonal',
  'Terapia de Aceptación y Compromiso',
  'Terapia Breve Estratégica',
  'Terapia de Procesamiento del Trauma (TPT)',
  'EMDR',
  'Terapia focalizada en el Trauma (TF-CBT)',
  'Terapias de Tercera Generación',
  'Teoría del Apego',
];

export const SUBSPECIALTIES_MOCK = [
  { value: 'Infato juvenil', label: 'Infato juvenil' },
  {
    value: 'Terapia Cognitivo Conductual',
    label: 'Terapia Cognitivo Conductual',
  },
  { value: 'Psicoterapia Psicodinámica', label: 'Psicoterapia Psicodinámica' },
  { value: 'Terapia Conductual', label: 'Terapia Conductual' },
  { value: 'Terapia Sistémica', label: 'Terapia Sistémica' },
  { value: 'Terapia Interpersonal', label: 'Terapia Interpersonal' },
  {
    value: 'Terapia de Aceptación y Compromiso',
    label: 'Terapia de Aceptación y Compromiso',
  },
  { value: 'Terapia Breve Estratégica', label: 'Terapia Breve Estratégica' },
  {
    value: 'Terapia de Procesamiento del Trauma (TPT)',
    label: 'Terapia de Procesamiento del Trauma (TPT)',
  },
  { value: 'EMDR', label: 'EMDR' },
  {
    value: 'Terapia focalizada en el Trauma (TF-CBT)',
    label: 'Terapia focalizada en el Trauma (TF-CBT)',
  },
  {
    value: 'Terapias de Tercera Generación',
    label: 'Terapias de Tercera Generación',
  },
  { value: 'Teoría del Apego', label: 'Teoría del Apego' },
];

export const PATIENTS_BUTTONS = [
  {
    title: '',
    items: [
      {
        name: 'notes',
        title: 'Tus Notas',
        icon: icon_pen,
        iconSize: 50,
        color: 'bg-[#E6F8FD]',
        route: 'notes',
      },
      {
        name: 'patient_info',
        title: 'Información del Paciente',
        icon: icon_people,
        iconSize: 50,
        color: 'bg-[#E6F8FD]',
        route: 'info',
      },
    ],
    width: 50,
  },
  {
    title: 'Información recogida fuera de terapia',
    items: [
      {
        name: 'autoregister',
        title: 'Autoregistro',
        icon: icon_folder,
        iconSize: 50,
        color: 'bg-[#F5FCF8]',
        route: 'autoregister',
      },
      {
        name: 'dairy',
        title: 'Diario terapeutico',
        icon: icon_paper,
        iconSize: 50,
        color: 'bg-[#F5FCF8]',
        route: 'therapeutic-diary',
      },
      {
        name: 'request',
        title: 'Biblioteca de recursos',
        icon: icon_square,
        iconSize: 50,
        color: 'bg-[#F5FCF8]',
        route: 'request-resource',
      },
      {
        name: 'tracking',
        title: 'Tracking Emocional',
        icon: icon_camera,
        iconSize: 50,
        color: 'bg-[#F5FCF8]',
        route: 'emotional-track',
      },
      {
        name: 'request_register',
        title: 'Actividad Fisica',
        icon: icon_time,
        iconSize: 50,
        color: 'bg-[#F5FCF8]',
        route: 'physical-activity',
      },
      {
        name: 'messages',
        title: 'Mensajes',
        icon: icon_message,
        iconSize: 50,
        color: 'bg-[#F5FCF8]',
        isSoon: 'border-[#6FA085] bg-[#6FA085]',
      },
    ],
    width: 33,
  },
  {
    title: 'Información recogida en terapia',
    items: [
      {
        name: 'transcription',
        title: 'Transcripciones',
        icon: icon_transcription,
        iconSize: 50,
        color: 'bg-[#FEFBF1]',
        route: 'transcriptions',
      },
    ],
    width: 33,
  },
  {
    title: 'Optimización del tratamiento:',
    items: [
      {
        name: 'resume',
        title: 'Resumen de la semana ',
        icon: icon_calendar,
        iconSize: 50,
        color: 'bg-[#F5F3FC]',
        route: 'week-resume',
      },
      {
        name: 'evolution',
        title: 'Evolución sintomatología',
        icon: icon_arrow,
        iconSize: 50,
        color: 'bg-[#F5F3FC]',
        route: 'symptom-evolution',
      },
      {
        name: 'resources',
        title: 'Recursos favoritos ',
        icon: icon_star,
        iconSize: 50,
        color: 'bg-[#F5F3FC]',
        route: 'resources-library',
      },
      {
        name: 'plan',
        title: 'Plan de intervención',
        icon: icon_plan,
        iconSize: 50,
        color: 'bg-[#F5F3FC]',
        isSoon: 'border-[#9F89DC] bg-[#9F89DC]',
      },
      {
        name: 'generate',
        title: 'Generar informes',
        icon: icon_generate,
        iconSize: 50,
        color: 'bg-[#F5F3FC]',
        isSoon: 'border-[#9F89DC] bg-[#9F89DC]',
      },
    ],
    width: 33,
  },
];

export const TAPS_PATIENTS = [
  {
    name: 'notes',
    title: 'Notas',
    route: 'patient/${id}/notes',
  },
  {
    name: 'transcriptions',
    title: 'Transcripciones',
    route: 'patient/${id}/transcriptions',
  },
];

export const PATIENT_NOTES = [
  {
    title: 'Sesión #08',
    date: '2024-04-20',
    description:
      'Maecenas leo odio, condimentum id, luctus nec, molestie sed, justo. Pellentesque viverra pede ac diam. Cras pellentesque volutpat dui.\n\nMaecenas tristique, est et tempus semper, est quam pharetra magna, ac consequat metus sapien ut nunc. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Mauris viverra diam vitae quam. Suspendisse potenti.\n\nNullam porttitor lacus at turpis. Donec posuere metus vitae ipsum. Aliquam non mauris.',
  },
  {
    title: 'Sesión #05',
    date: '2024-04-20',
    description:
      'Nulla ut erat id mauris vulputate elementum. Nullam varius. Nulla facilisi.',
  },
  {
    title: 'Sesión #06',
    date: '2024-05-20',
    description:
      'Nullam porttitor lacus at turpis. Donec posuere metus vitae ipsum. Aliquam non mauris.',
  },
  {
    title: 'Sesión #08',
    date: '2024-04-20',
    description:
      'Pellentesque at nulla. Suspendisse potenti. Cras in purus eu magna vulputate luctus.\n\nCum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.',
  },
  {
    title: 'Sesión #01',
    date: '2024-04-20',
    description:
      'Sed ante. Vivamus tortor. Duis mattis egestas metus.\n\nAenean fermentum. Donec ut mauris eget massa tempor convallis. Nulla neque libero, convallis eget, eleifend luctus, ultricies eu, nibh.',
  },
  {
    title: 'Sesión #06',
    date: '2024-04-20',
    description:
      'Proin interdum mauris non ligula pellentesque ultrices. Phasellus id sapien in sapien iaculis congue. Vivamus metus arcu, adipiscing molestie, hendrerit at, vulputate vitae, nisl.\n\nAenean lectus. Pellentesque eget nunc. Donec quis orci eget orci vehicula condimentum.',
  },
  {
    title: 'Sesión #05',
    date: '2024-04-20',
    description:
      'Cras mi pede, malesuada in, imperdiet et, commodo vulputate, justo. In blandit ultrices enim. Lorem ipsum dolor sit amet, consectetuer adipiscing elit.',
  },
  {
    title: 'Sesión #08',
    date: '2024-04-20',
    description:
      'Fusce posuere felis sed lacus. Morbi sem mauris, laoreet ut, rhoncus aliquet, pulvinar sed, nisl. Nunc rhoncus dui vel sem.\n\nSed sagittis. Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci. Nullam molestie nibh in lectus.\n\nPellentesque at nulla. Suspendisse potenti. Cras in purus eu magna vulputate luctus.',
  },
  {
    title: 'Sesión #04',
    date: '2024-04-20',
    description:
      'Integer tincidunt ante vel ipsum. Praesent blandit lacinia erat. Vestibulum sed magna at nunc commodo placerat.',
  },
  {
    title: 'Sesión #04',
    date: '2024-05-20',
    description:
      'Duis aliquam convallis nunc. Proin at turpis a pede posuere nonummy. Integer non velit.\n\nDonec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi. Integer ac neque.\n\nDuis bibendum. Morbi non quam nec dui luctus rutrum. Nulla tellus.',
  },
  {
    title: 'Sesión #08',
    date: '2024-04-20',
    description:
      'In quis justo. Maecenas rhoncus aliquam lacus. Morbi quis tortor id nulla ultrices aliquet.',
  },
  {
    title: 'Sesión #03',
    date: '2024-08-20',
    description:
      'Integer tincidunt ante vel ipsum. Praesent blandit lacinia erat. Vestibulum sed magna at nunc commodo placerat.\n\nPraesent blandit. Nam nulla. Integer pede justo, lacinia eget, tincidunt eget, tempus vel, pede.\n\nMorbi porttitor lorem id ligula. Suspendisse ornare consequat lectus. In est risus, auctor sed, tristique in, tempus sit amet, sem.',
  },
  {
    title: 'Sesión #07',
    date: '2024-04-20',
    description:
      'Fusce posuere felis sed lacus. Morbi sem mauris, laoreet ut, rhoncus aliquet, pulvinar sed, nisl. Nunc rhoncus dui vel sem.\n\nSed sagittis. Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci. Nullam molestie nibh in lectus.\n\nPellentesque at nulla. Suspendisse potenti. Cras in purus eu magna vulputate luctus.',
  },
  {
    title: 'Sesión #08',
    date: '2024-04-20',
    description:
      'Proin leo odio, porttitor id, consequat in, consequat ut, nulla. Sed accumsan felis. Ut at dolor quis odio consequat varius.\n\nInteger ac leo. Pellentesque ultrices mattis odio. Donec vitae nisi.',
  },
  {
    title: 'Sesión #10',
    date: '2024-04-20',
    description:
      'Morbi porttitor lorem id ligula. Suspendisse ornare consequat lectus. In est risus, auctor sed, tristique in, tempus sit amet, sem.',
  },
];

export const OPTIONS = [
  {
    title: 'Seleccione una opcion',
    id: 'option',
    value: 'option',
  },
];

export const PATIENT_INFO_BUTTONS = [
  {
    id: 'data',
    image: icon_data,
    title: 'Datos del paciente',
  },
  {
    id: 'history',
    image: icon_history,
    title: 'Historial médico',
  },
  {
    id: 'psico',
    image: icon_psico,
    title: 'Consultas de psicoterapia',
  },
  {
    id: 'treatment',
    image: icon_treatment,
    title: 'Tratamiento',
  },
];

export const SYMPTOM_LEVEL = ['Ligero', 'Medio', 'Fuerte', 'Severo'];
export const QUESTIONNAIRE_NAME = {
  BAI: 'Beck Anxiety Inventory (BAI)',
  'BDI-II': 'Beck Depreesion Inventary (BDI II)',
  WAIS: 'Working Alliance Inventory (WAIS)',
};

export const EmotionsImages = [
  triste,
  mal,
  regular,
  bien,
  muy_bien,
  agradable,
  muy_agradable,
];

export const EmotionsHeaders = [
  'Muy Mal',
  'Algo Mal',
  'Mal',
  'Normal',
  'Agradable',
  'Algo Agradable',
  'Muy Agradable',
];

export const EmotionsEnumHeaders = {
  veryBad: 'Muy Mal',
  bad: 'Mal',
  somewhatBad: 'Algo Mal',
  normal: 'Normal',
  somewhatGood: 'Algo Agradable',
  good: 'Agradable',
  veryGood: 'Muy Agradable',
};

export const TEMPLATE_STANDAR_CONSULTATION = `
<div>
  <p><strong>Plantilla consulta estándar:</strong></p>
  <p><strong>Notas de la consulta:</strong></p>
  <p>&nbsp;</p>
  <p>&nbsp;</p>
  <p>&nbsp;</p>
  <p><strong>Resumen de la terapia:</strong></p>
  <p>&nbsp;</p>
  <p>&nbsp;</p>
  <p>&nbsp;</p>
  <p><strong>Prescripciones hasta siguiente consulta:</strong></p>
</div>
`;

export const TEMPLATE_FAMILY_ORIGIN = `
<div>
  <p><strong>Plantilla Familia de origen y familia del cónyuge:</strong></p>
  <p><strong>Información general:</strong></p>
  <ol>
    <li>Háblame de cómo era tu familia</li>
    <li>¿Cómo definirías el ambiente que había en casa?</li>
    <li>¿Qué tal se llevaban tus padres?</li>
    <li>¿Solían tener discusiones?</li>
    <li>¿Se produjeron malos tratos?</li>
    <li>¿Llegaron a hablar de separación o se separaron?</li>
    <li>¿Cómo viviste la relación de tus padres?</li>
    <li>¿Cómo crees que te ha repercutido?</li>
    <li>¿Cómo dirías que fue tu infancia en casa?</li>
    <li>¿Tienes hermanos?</li>
    <li>¿Qué posición tienes?</li>
    <li>¿Qué relación tenías con ellos?</li>
  </ol>

  <p><strong>Infancia en familia de origen:</strong></p>
  <ol start="13">
    <li>¿Cómo eran tus padres contigo?</li>
    <li>¿Recuerdas una relación autoritaria, o un ambiente en el que podíais negociar las cosas?</li>
    <li>¿Eran tus padres exigentes contigo?</li>
    <li>¿Era normal mostrar afecto en casa?</li>
    <li>¿Te sentías valorado?</li>
  </ol>

  <p><strong>Actualidad con la familia de origen y la familia del otro cónyuge:</strong></p>
  <ol start="18">
    <li>¿Qué relación tienes con tu familia?</li>
    <li>¿Ha habido algún acontecimiento que haya repercutido en las relaciones intrafamiliares?</li>
    <li>¿Qué relación tienes con la familia de tu cónyuge?</li>
  </ol>
</div>
`;

export const TEMPLATE_FIRTS_SESION_ADULT = `
<div>
  <p><strong>Consulta de psicoterapia:</strong></p>
  <ol>
    <li>¿Cuál es el motivo de consulta?</li>
    <li>¿Has venido por iniciativa propia?</li>
    <li>¿Cuándo aparecieron los primeros síntomas o preocupaciones?</li>
    <li>¿Cuáles son?</li>
    <li>¿Coincidieron en el tiempo con algún acontecimiento?</li>
    <li>¿Cómo ha sido la evolución de estos síntomas o preocupaciones hasta la actualidad?</li>
    <li>¿Qué repercusiones han tenido estos sintomatología en tu vida diaria?</li>
    <li>¿Qué esperas del tratamiento?</li>
    <li>¿Has ido a terapia previamente? ¿Durante cuánto tiempo?</li>
    <li>¿Por qué has decidido cambiar?</li>
  </ol>

  <p><strong>Análisis funcional de la conducta problema:</strong></p>
  <ol start="11">
    <li>¿Cuál es la conducta/acción/pensamiento?</li>
    <li>¿Con qué frecuencia se realiza?</li>
    <li>¿En qué momentos y lugares ocurre?</li>
    <li>¿Qué ocurre después de la conducta?</li>
  </ol>

  <p><strong>Datos del paciente:</strong></p>
  <p><strong>Información básica:</strong></p>
  <ol start="15">
    <li>Edad:</li>
    <li>¿Estás casado, soltero?</li>
    <li>¿Tienes hijos?</li>
    <li>¿Cuántos hijos?</li>
    <li>¿Qué edades tienen?</li>
    <li>¿Cómo es su relación con ellos?</li>
    <li>¿Y con su pareja?</li>
    <li>¿Quiénes viven en el hogar?</li>
  </ol>

  <p><strong>Historial médico:</strong></p>
  <p><strong>Enfermedades previas:</strong></p>
  <ol start="13">
    <li>¿Tienes enfermedades previas?</li>
    <li>¿Ha habido hospitalizaciones previas por salud mental?</li>
  </ol>

  <p><strong>Enfermedad de familiares:</strong></p>
  <ol start="15">
    <li>¿Hay enfermedades de familiares?</li>
    <li>¿Cuáles?</li>
  </ol>

  <p><strong>Farmacología:</strong></p>
  <ol start="17">
    <li>¿Tomas alguna medicación? ¿Cuál?</li>
    <li>¿Cuánto tiempo llevas tomando la medicación?</li>
    <li>¿Qué dosis?</li>
    <li>¿Qué efectos adversos has sufrido de la medicación?</li>
    <li>¿Has tenido secuelas por los efectos adversos?</li>
  </ol>

  <p><strong>Salud física:</strong></p>
  <ol start="22">
    <li>¿Haces actividad física?</li>
    <li>(Podrías hablar acerca de cómo son tus hábitos de alimentación?)</li>
  </ol>

  <p><strong>Antecedentes familiares:</strong></p>
  <ol start="24">
    <li>¿Han tenido o tienen familiares tuyos alguna enfermedad?</li>
    <li>¿Cuál?</li>
  </ol>

  <p><strong>Consumo de sustancias:</strong></p>
  <ol start="26">
    <li>¿Consumes alcohol o alguna otra sustancia?</li>
    <li>¿Con qué frecuencia?</li>
  </ol>
</div>
`;

export const TEMPLATE_PARTNERS = `
<div>
  <p><strong>Plantilla Historia de Terapia de Pareja:</strong></p>
  
  <p><strong>Relación en el tiempo:</strong></p>
  <ol>
    <li>¿Cómo se conocieron?</li>
    <li>¿A qué edad se conocieron?</li>
    <li>¿Cómo fueron las primeras citas?</li>
    <li>¿Sabías desde qué punto estabas interesado/a en el otro?</li>
    <li>¿Cómo describirías vuestro noviazgo?</li>
    <li>¿Cuánto tiempo estuvieron de novios?</li>
    <li>¿Cuándo comenzaron a vivir juntos?</li>
    <li>¿Cómo fue el inicio de la convivencia?</li>
    <li>¿Cómo fue organizable?</li>
    <li>¿Cómo respecto a la organización doméstica, fueron decisiones sencillas o conflictivas?</li>
    <li>¿Cómo describirías vuestra relación más íntima/sexual?</li>
    <li>¿Crees que esperáis lo mismo de la intimidad?</li>
    <li>¿Creéis que ambos estáis satisfechos en las mismas?</li>
  </ol>

  <p><strong>En caso de no tener hijos:</strong></p>
  <ol start="14">
    <li>¿Habéis hablado del tema?</li>
    <li>¿Tenéis las mismas expectativas al respecto?</li>
  </ol>

  <p><strong>En caso de tener hijos:</strong></p>
  <ol start="16">
    <li>¿Cómo tomasteis la decisión de ser padres?</li>
    <li>¿Hubo diferencias de expectativas al respecto?</li>
    <li>¿Cómo lo gestionasteis?</li>
    <li>Con respecto a los conflictos en torno a la crianza de los hijos, ¿cómo los gestionasteis?</li>
  </ol>

  <p><strong>Familia extensa:</strong></p>
  <ol start="20">
    <li>¿Qué relación tenéis con las familias extensas?</li>
    <li>¿Tenéis las mismas expectativas de la relación que queréis tener con las mismas?</li>
    <li>¿Cómo gestionáis cuando no estáis de acuerdo en temas relacionados con las familias extensas?</li>
    <li>¿Las discutís entre ambos?</li>
    <li>¿Hay algún familiar dependiente?</li>
    <li>¿Quién se hace cargo del mismo?</li>
    <li>¿Cómo lo vivís?</li>
  </ol>

  <p><strong>Actualmente:</strong></p>
  <ol start="27">
    <li>¿Cuándo empezasteis a notar que las cosas no iban bien?</li>
    <li>¿Coincidió con algún desencadenante?</li>
    <li>¿Cómo habéis actualmente vuestra relación?</li>
    <li>¿Cómo describirías vuestra relación en vuestros hijos?</li>
    <li>¿Cómo repartís las tareas que refieren al hogar y a los hijos?</li>
    <li>¿Qué expectativas tenéis cada uno con respecto a la gestión de las tareas del hogar y de los hijos?</li>
    <li>¿Cómo gestionáis cuando hay una diferencia de opiniones con respecto a la gestión de las tareas del hogar y de los hijos? ¿Tenéis algún protocolo?</li>
  </ol>
</div>
`;

export const TEMPLATE_CHILDREN = `
<div>
  <p><strong>Primera sesión con menores:</strong></p>
  
  <p><strong>Datos del menor:</strong></p>
  <ol>
    <li>Fecha de nacimiento:</li>
    <li>Edad actual:</li>
    <li>Curso escolar:</li>
    <li>Centro escolar:</li>
    <li>¿Ha repetido algún curso?</li>
    <li>Número de hermanos:</li>
    <li>Número de progenitores:</li>
    <li>¿Quiénes conviven en el núcleo familiar?</li>
  </ol>

  <p><strong>Motivo de consulta:</strong></p>
  <ol start="9">
    <li>Motivo de consulta:</li>
    <li>¿Cuándo empezaron los síntomas o las preocupaciones?</li>
    <li>¿Coincidieron en el tiempo con algún acontecimiento?</li>
    <li>¿Cómo ha sido la evolución de esa sintomatología o preocupaciones hasta la actualidad?</li>
    <li>¿Qué espera del tratamiento?</li>
    <li>¿Ha ido a terapia previamente?</li>
    <li>¿Por qué ha decidido cambiar?</li>
  </ol>

  <p><strong>Análisis funcional de la conducta problema:</strong></p>
  <ol start="1">
    <li>¿Cuál es la conducta?</li>
    <li>¿Con cuánta frecuencia se realiza?</li>
    <li>¿En qué lugares y momentos ocurre?</li>
    <li>¿Qué ocurre después de la conducta?</li>
  </ol>

  <p><strong>Historia evolutiva del menor:</strong></p>

  <p><strong>Gestación y parto:</strong></p>
  <ol start="5">
    <li>¿Cómo fue el embarazo?</li>
    <li>¿Cómo fue el parto?</li>
    <li>¿Alguna patología identificada en el embarazo?</li>
    <li>¿Qué pesó al nacer?</li>
  </ol>

  <p><strong>Alimentación:</strong></p>
  <ol start="9">
    <li>¿Hubo lactancia materna? ¿Cómo la vivió?</li>
    <li>¿Cómo fue la transición a la alimentación complementaria?</li>
    <li>¿Cómo fue la incorporación de distintas texturas en la alimentación?</li>
  </ol>

  <p><strong>Desarrollo psicomotor:</strong></p>
  <ol start="12">
    <li>¿Cuándo fue el inicio del gateo? (aproximadamente)</li>
    <li>¿Cuándo fue el inicio de la marcha autónoma? (aproximadamente)</li>
    <li>¿Algo que destacar con respecto a la psicomotricidad gruesa?</li>
    <li>¿Algo que destacar con respecto a la psicomotricidad fina?</li>
  </ol>

  <p><strong>Desarrollo del lenguaje:</strong></p>
  <ol start="16">
    <li>¿Algo que destacar acerca del período del balbuceo?</li>
    <li>¿Cuándo fueron sus primeras palabras? (aproximadamente)</li>
    <li>¿Cuándo fueron las primeras frases? (aproximadamente)</li>
    <li>¿Alguna observación en el lenguaje actual, a la hora de expresarse o de comprender lo que se le dice?</li>
  </ol>

  <p><strong>Control de esfínteres:</strong></p>
  <ol start="20">
    <li>¿A qué edad dejó de utilizar pañales de día?</li>
    <li>¿A qué edad dejó de utilizar pañales de noche?</li>
    <li>¿Ha habido alguna regresión después de haber dejado el pañal? ¿Coincide con algún acontecimiento próximo en el tiempo?</li>
  </ol>

  <p><strong>Hábitos:</strong></p>
  <ol start="23">
    <li>¿Tiene o ha tenido problemas para dormir?</li>
    <li>¿Qué rutinas hace antes de acostarse?</li>
    <li>¿Realiza actividades de autonomía como vestirse, ducharse, ayudar en tareas del hogar?</li>
  </ol>

  <p><strong>Relaciones interpersonales:</strong></p>
  <ol start="26">
    <li>¿Con los adultos es capaz de pedir ayuda?</li>
    <li>¿Con los adultos es capaz de mantener contacto ocular?</li>
    <li>¿Con los adultos acepta normas y reglas?</li>
    <li>¿Cómo se comporta con sus iguales?</li>
    <li>¿Ha sufrido agresiones?</li>
    <li>¿Alguna conducta que le llame la atención y que desee añadir?</li>
  </ol>

  <p><strong>Juego:</strong></p>
  <ol start="32">
    <li>¿Qué tipo de juego le gusta?</li>
    <li>¿Prefiere jugar solo o acompañado?</li>
    <li>¿Cuánta televisión, tablet o móvil consume diariamente?</li>
  </ol>

  <p><strong>Gestión socio-emocional:</strong></p>
  <ol start="35">
    <li>¿Cómo vive la frustración?</li>
    <li>¿Ha habido o hay conductas disruptivas?</li>
    <li>¿Cómo vive las situaciones en que no le salen las cosas?</li>
  </ol>

  <p><strong>Escolarización: Escuela Infantil 1er Ciclo</strong></p>
  <ol start="38">
    <li>¿A qué Escuela Infantil acudió?</li>
    <li>¿A qué edad comenzó a ir?</li>
    <li>¿Cómo vivió la adaptación?</li>
    <li>¿Qué feedback os daban los profesores?</li>
  </ol>

  <p><strong>Escolarización: Escuela Infantil 2do Ciclo</strong></p>
  <ol start="42">
    <li>¿A qué colegio acudió?</li>
    <li>¿Cómo vivió la adaptación?</li>
    <li>¿Qué feedback os daban los profesores?</li>
  </ol>

  <p><strong>Escolarización: Primaria</strong></p>
  <ol start="45">
    <li>¿A qué colegio acudió?</li>
    <li>¿Qué asignaturas le gustan más?</li>
    <li>¿Qué asignaturas le gustan menos?</li>
    <li>¿Disfruta yendo al colegio?</li>
    <li>¿Ha habido algún acontecimiento en el colegio importante?</li>
    <li>¿Habéis notado cambios en su rendimiento?</li>
  </ol>

  <p><strong>Escolarización: Secundaria</strong></p>
  <ol start="51">
    <li>¿A qué colegio acudió?</li>
    <li>¿Qué asignaturas le gustan más?</li>
    <li>¿Qué asignaturas le gustan menos?</li>
    <li>¿Disfruta yendo al colegio?</li>
    <li>¿Ha habido algún acontecimiento en el colegio importante?</li>
    <li>¿Habéis notado cambios en su rendimiento?</li>
  </ol>

  <p><strong>Objetivos terapéuticos:</strong></p>
  <ol start="57">
    <li>¿Hay alguna observación que el terapeuta desee añadir?</li>
    <li>Objetivos terapéuticos iniciales</li>
    <li>Posible orientación diagnóstica o hipótesis del caso</li>
  </ol>
</div>
`;

function isPar(number: number) {
  return number % 2 === 0;
}

function isImpar(number: number) {
  return number % 2 !== 0;
}

export function generateBAIHtml(
  respuestas: any[],
  result: string,
  date: string
) {
  const items = [
    'Torpe o entumecido',
    'Acalorado',
    'Con temblor en las piernas',
    'Incapaz de relajarse',
    'Con temor a que ocurra lo peor',
    'Mareado, o que se le va la cabeza',
    'Con latidos del corazón fuertes y acelerados',
    'Inestable',
    'Atemorizado o asustado',
    'Nervioso',
    'Con sensación de bloqueo',
    'Con temblores en las manos',
    'Inquieto, inseguro',
    'Con miedo a perder el control',
    'Con sensación de ahogo',
    'Con terror a morir',
    'Con mareo',
    'Con problemas digestivos',
    'Con adormecimientos',
    'Con dolor facial',
    'Con sudores, fríos o calientes',
  ];

  const isPar = (index: number) => index % 2 === 0;

  let html = `
  <!DOCTYPE html>
  <html lang="es">
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Inventario de Ansiedad de Beck (BAI)</title>
    <style>
      body {
        font-family: Arial, sans-serif;
        background-color: #fff;
        margin: 0;
        padding: 20px;
      }

      .container {
        max-width: 800px;
        min-width: 800px;
        margin: 0 auto;
        border: 1px solid #ddd;
        overflow: hidden;
        border-radius: 50px;
        page-break-inside: avoid;
      }

      .header {
        text-align: left;
        max-width: 500px;
        min-width: 500px;
        margin-bottom: 20px;
      }

      .header h1 {
        font-size: 24px;
        margin: 0;
        color: #333;
      }

      .header p.result {
        font-size: 25px;
        color: #9F89DC;
        margin: 5px 0;
        font-weight: bold;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        page-break-inside: auto;
      }

      th, td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: center;
      }

      th {
        background-color: #f3e8ff;
        color: #333;
      }

      td {
        font-size: 10px;
      }

      td:first-child {
        text-align: left;
        font-weight: bold;
      }

      tr {
        page-break-inside: avoid; /* Evita que las filas se dividan entre páginas */
      }

      .page-break {
        page-break-before: always; /* Crea un salto de página */
      }
    </style>
  </head>
  <body>
    <div style="display: flex; justify-content: space-between">
      <div>
        <img src="https://pnsnrqedwbrugrblbkxm.supabase.co/storage/v1/object/public/profile-images/logo.png" width="60px" height="60px" alt="logo"/>
      </div>
      <div class="header">
          <h1>Inventario de Ansiedad de Beck (BAI)</h1>
          <p class="result">${result}</p>
          <p style="margin: 0;">Fecha del cuestionario: ${date}</p>
      </div>
    </div>
    <div class="container">
      <table>
        <thead>
          <tr>
            <th style="background-color: #fff; border: none;"></th>
            <th>No</th>
            <th>Leve</th>
            <th>Moderado</th>
            <th>Bastante</th>
          </tr>
        </thead>
        <tbody>`;

  items.forEach((item, index) => {
    const respuesta = respuestas[index];

    html += `
      <tr style="${isPar(index) ? 'background-color: #f3e8ff;' : ''}">
        <td>${index + 1}. ${item}</td>
        <td><input type="radio" name="q${index}" ${
      respuesta === 0 ? 'checked' : ''
    }></td>
        <td><input type="radio" name="q${index}" ${
      respuesta === 1 ? 'checked' : ''
    }></td>
        <td><input type="radio" name="q${index}" ${
      respuesta === 2 ? 'checked' : ''
    }></td>
        <td><input type="radio" name="q${index}" ${
      respuesta === 3 ? 'checked' : ''
    }></td>
      </tr>`;
  });

  html += `
        </tbody>
      </table>

      <div class="footer" style="text-align: center; margin-top: 20px; font-size: 12px; color: #888;">
        © 2024 - Inventario de Ansiedad de Beck (BAI)
      </div>
    </div>

  </body>
  </html>`;

  return html;
}

const cuestionario = [
  {
    title: 'Tristeza',
    text: 'Seleccione cómo se siente:',
    options: [
      'No me siento triste',
      'Me siento triste gran parte del tiempo',
      'Me siento triste todo el tiempo',
      'Estoy tan triste o infeliz que no puedo soportarlo',
    ],
  },
  {
    title: 'Pesimismo',
    text: 'Seleccione cómo se siente respecto al futuro:',
    options: [
      'No estoy desalentado respecto de mi futuro',
      'Me siento más desalentado respecto de mi futuro de lo que solía estarlo',
      'No espero que las cosas funcionen para mí',
      'Siento que no hay esperanza para mi futuro y que sólo puede empeorar',
    ],
  },
  {
    title: 'Fracaso',
    text: 'Seleccione cómo se siente respecto al fracaso:',
    options: [
      'No me siento como un fracasado',
      'He fracasado más de lo que hubiera debido',
      'Cuando miro hacia atrás, veo muchos fracasos',
      'Siento que soy un fracaso total',
    ],
  },
  {
    title: 'Pérdida de placer',
    text: 'Seleccione cuánto placer experimenta:',
    options: [
      'Disfruto de las cosas como siempre',
      'No disfruto tanto de las cosas como solía',
      'Obtengo muy poco placer de las cosas que solía disfrutar',
      'No puedo obtener ningún placer de las cosas que solía disfrutar',
    ],
  },
  {
    title: 'Sentimientos de culpa',
    text: 'Seleccione cómo se siente respecto a la culpa:',
    options: [
      'No me siento particularmente culpable',
      'Me siento culpable respecto de varias cosas que he hecho o que debería haber hecho',
      'Me siento bastante culpable la mayor parte del tiempo',
      'Me siento culpable todo el tiempo',
    ],
  },
  {
    title: 'Castigo',
    text: 'Seleccione si siente que debe ser castigado:',
    options: [
      'No siento que esté siendo castigado',
      'Siento que quizás pueda ser castigado',
      'Espero ser castigado',
      'Siento que estoy siendo castigado',
    ],
  },
  {
    title: 'Insatisfacción',
    text: 'Seleccione su nivel de insatisfacción consigo mismo:',
    options: [
      'Estoy satisfecho conmigo mismo',
      'No estoy tan satisfecho conmigo mismo como solía estarlo',
      'Estoy decepcionado de mí mismo',
      'No me gusto nada a mí mismo',
    ],
  },
  {
    title: 'Autocrítica',
    text: 'Seleccione cómo se critica a sí mismo:',
    options: [
      'No me critico ni me culpo más de lo habitual',
      'Estoy más crítico conmigo mismo que antes',
      'Me critico por todos mis errores',
      'Me culpo por todo lo malo que sucede',
    ],
  },
  {
    title: 'Pensamientos suicidas',
    text: 'Seleccione si ha tenido pensamientos suicidas:',
    options: [
      'No tengo pensamientos de suicidio',
      'Tengo pensamientos de suicidio pero no los llevaría a cabo',
      'Querría suicidarme',
      'Me suicidaría si tuviera la oportunidad',
    ],
  },
  {
    title: 'Llanto',
    text: 'Seleccione cuánto ha llorado recientemente:',
    options: [
      'No lloro más de lo habitual',
      'Lloro más de lo que solía',
      'Lloro todo el tiempo',
      'Antes podía llorar, pero ahora no puedo llorar aunque lo desee',
    ],
  },
  {
    title: 'Inquietud',
    text: 'Seleccione cuán inquieto se siente:',
    options: [
      'No estoy más inquieto o nervioso que de costumbre',
      'Me siento más inquieto o nervioso que de costumbre',
      'Estoy tan inquieto o agitado que me cuesta permanecer quieto',
      'Estoy tan inquieto o agitado que debo estar siempre en movimiento',
    ],
  },
  {
    title: 'Pérdida de interés',
    text: 'Seleccione cuánto interés ha perdido en actividades:',
    options: [
      'No he perdido interés en otras personas o actividades',
      'Estoy menos interesado en otras personas o cosas de lo que solía estarlo',
      'He perdido casi todo el interés en otras personas o cosas',
      'Es difícil interesarme por algo',
    ],
  },
  {
    title: 'Indecisión',
    text: 'Seleccione si le resulta difícil tomar decisiones:',
    options: [
      'Tomo decisiones tan bien como siempre',
      'Me resulta más difícil tomar decisiones que de costumbre',
      'Tengo mucha más dificultad para tomar decisiones que antes',
      'Ya no puedo tomar decisiones en absoluto',
    ],
  },
  {
    title: 'Inutilidad',
    text: 'Seleccione cuánto se siente inútil:',
    options: [
      'No me siento inútil',
      'Me siento más inútil de lo que solía sentirme',
      'Me siento bastante inútil',
      'Me siento completamente inútil',
    ],
  },
  {
    title: 'Pérdida de energía',
    text: 'Seleccione cuánta energía siente que ha perdido:',
    options: [
      'Tengo tanta energía como siempre',
      'Tengo menos energía que de costumbre',
      'No tengo suficiente energía para hacer muchas cosas',
      'No tengo energía suficiente para hacer nada',
    ],
  },
  {
    title: 'Cambios en el sueño',
    text: 'Seleccione cómo ha cambiado su sueño:',
    options: [
      'No he experimentado cambios en mi sueño',
      'Duermo un poco más/menos de lo habitual',
      'Duermo bastante más/menos de lo habitual',
      'Duermo la mayor parte del día o me despierto 1-2 horas antes y no puedo volver a dormir',
    ],
  },
  {
    title: 'Irritabilidad',
    text: 'Seleccione cuán irritable se siente:',
    options: [
      'No estoy más irritable de lo habitual',
      'Estoy más irritable de lo que solía estarlo',
      'Estoy mucho más irritable de lo que solía estarlo',
      'Estoy irritable todo el tiempo',
    ],
  },
  {
    title: 'Cambios en el apetito',
    text: 'Seleccione cómo ha cambiado su apetito:',
    options: [
      'No he experimentado cambios en mi apetito',
      'Mi apetito es un poco menor o mayor que de costumbre',
      'Mi apetito es mucho menor o mayor que antes',
      'No tengo apetito en absoluto o quiero comer todo el tiempo',
    ],
  },
  {
    title: 'Dificultad para concentrarse',
    text: 'Seleccione cuánta dificultad tiene para concentrarse:',
    options: [
      'Puedo concentrarme tan bien como siempre',
      'No puedo concentrarme tan bien como antes',
      'Me es difícil concentrarme por mucho tiempo',
      'Encuentro que no puedo concentrarme en nada',
    ],
  },
  {
    title: 'Cansancio o fatiga',
    text: 'Seleccione cuánto cansancio siente:',
    options: [
      'No estoy más cansado o fatigado de lo habitual',
      'Me canso o fatigo más fácilmente que antes',
      'Estoy demasiado cansado o fatigado para hacer muchas de las cosas que solía hacer',
      'Estoy demasiado cansado o fatigado para hacer la mayoría de las cosas que solía hacer',
    ],
  },
  {
    title: 'Pérdida de interés en el sexo',
    text: 'Seleccione cuánto interés ha perdido en el sexo:',
    options: [
      'No he notado ningún cambio reciente en mi interés por el sexo',
      'Estoy menos interesado en el sexo de lo que solía estarlo',
      'Estoy mucho menos interesado en el sexo ahora',
      'He perdido completamente el interés en el sexo',
    ],
  },
];

function joinEachFour(array: any[]) {
  const result = [];

  for (let i = 0; i < array.length; i += 4) {
    const grupo = array.slice(i, i + 4).join('');
    result.push(grupo);
  }

  return result;
}

export function generarHTMLBDI(
  respuestas: any[],
  result: string,
  date: string
) {
  const preguntasHTML = cuestionario.map((pregunta, index) => {
    const opciones = pregunta.options
      .map((option, idx) => {
        const checked =
          idx === respuestas[index]
            ? `<input type="radio" name="q${idx}-${index}" checked="true"}>`
            : `<input type="radio" name="q${idx}-${index}"}>`; // Marca la opción seleccionada

        return `<p>${checked} ${option}</p>`;
      })
      .join('');

    return `
      <div class="section" style="${
        isPar(index) ? 'background-color: #F5F3FC' : ''
      }">
        <h2>${pregunta.title}</h2>
        <div class="question">
          <p>${pregunta.text}</p>
          <tr>
            ${opciones}
          </tr>
        </div>
      </div>
    `;
  });

  const sections = joinEachFour(preguntasHTML);

  return `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Inventario de Depresión de Beck (BDI-II)</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          background-color: #fff;
          margin: 0;
          padding: 20px;
        }

        .header {
          text-align: left;
          max-width: 500px;
          min-width: 500px;
          margin-bottom: 20px;
        }

        .header h1 {
          font-size: 24px;
          margin: 0;
          color: #333;
        }

        .header p.result {
          font-size: 25px;
          color: #9F89DC;
          margin: 5px 0;
          font-weight: bold;
        }

        .section {
          margin-bottom: 20px;
          border: 1px solid #888888;
          border-radius: 40px;
          padding: 20px;
          page-break-inside: avoid; /* Evita que la sección se divida en dos páginas */
        }

        .section h2 {
          font-size: 18px;
          color: #333;
          margin-bottom: 10px;
        }

        .question {
          margin-bottom: 10px;
        }

        .question p {
          font-size: 14px;
          margin: 0;
        }

        .options {
          margin-left: 20px;
        }

        .options p {
          font-size: 14px;
          margin: 2px 0;
        }

        .page-break {
          page-break-before: always; /* Fuerza un salto de página */
        }
      </style>
    </head>
    <body>
      <div style="display: flex; justify-content: space-between">
        <div>
          <img src="https://pnsnrqedwbrugrblbkxm.supabase.co/storage/v1/object/public/profile-images/logo.png" width="60px" height="60px" alt="logo"/>
        </div>
        <div class="header">
            <h1>Inventario de depresión de Beck (BDI-II)</h1>
            <p class="result">${result}</p>
            <p style="margin: 0;">Fecha del cuestionario: ${date}</p>
        </div>
      </div>
      <div class="page">
        ${sections}
      </div>
    </body>
    </html>
  `;
}

const cuestionarioWAIS = [
  {
    title: 'Objetivos',
    questions: [
      'Mi terapeuta y yo estamos de acuerdo en los pasos necesarios para mejorar mi situación.',
      'Mi terapeuta y yo estamos de acuerdo en lo que es importante para mí en la terapia.',
      'Mi terapeuta y yo trabajamos como un equipo en la terapia.',
      'Mi terapeuta y yo tenemos un acuerdo mutuo sobre los objetivos de la terapia.',
    ],
  },
  {
    title: 'Tareas',
    questions: [
      'Lo que hago en terapia me ayudará a lograr los cambios que deseo.',
      'Creo que mi terapeuta está al tanto de las técnicas de terapia que me serán útiles.',
      'Estoy confiado en la forma en que trabajamos para resolver mis problemas.',
      'Creo que las cosas que hacemos en la terapia realmente me ayudan.',
    ],
  },
  {
    title: 'Vínculo',
    questions: [
      'Siento que mi terapeuta me aprecia como persona.',
      'Siento que mi terapeuta realmente comprende mis preocupaciones.',
      'Siento que mi terapeuta me respeta.',
      'De muy buena gana puedo hablar con mi terapeuta.',
    ],
  },
];

export function generarHTMLWAIS(
  respuestas: number[],
  result: string,
  date: string
) {
  const escala = [
    'Nunca',
    'Casi nunca',
    'Ocasionalmente',
    'A veces',
    'Frecuentemente',
    'Casi siempre',
    'Siempre',
  ];

  const preguntasHTML = cuestionarioWAIS
    .map((seccion, index) => {
      const preguntasSeccion = seccion.questions
        .map((pregunta, idx) => {
          const opciones = escala
            .map((opcion, i) => {
              const checked =
                i + 1 === respuestas[idx]
                  ? `<input type="radio" name="q${idx}-${index}" checked="true">`
                  : `<input type="radio" name="q${idx}-${index}">`;
              return `<p>${checked} ${opcion}</p>`;
            })
            .join('');

          return `
        <div class="question">
          <p>${pregunta}</p>
          <div class="options">
            ${opciones}
          </div>
        </div>
      `;
        })
        .join('');

      return `
      <div class="section" style="${
        index % 2 === 0 ? 'background-color: #F5F3FC;' : ''
      }">
        <h2>${seccion.title}</h2>
        ${preguntasSeccion}
      </div>
    `;
    })
    .join('');

  return `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Inventario WAIS (Alianza terapéutica)</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          background-color: #fff;
          margin: 0;
          padding: 20px;
        }

        .header {
          text-align: left;
          max-width: 500px;
          min-width: 500px;
          margin-bottom: 20px;
        }

        .header h1 {
          font-size: 24px;
          margin: 0;
          color: #333;
        }

        .header p.result {
          font-size: 25px;
          color: #9F89DC;
          margin: 5px 0;
          font-weight: bold;
        }

        .section {
          margin-bottom: 20px;
          border: 1px solid #888888;
          border-radius: 40px;
          padding: 20px;
          page-break-inside: avoid; /* Evita que la sección se divida entre páginas */
        }

        .section h2 {
          font-size: 18px;
          color: #333;
          margin-bottom: 10px;
        }

        .question {
          margin-bottom: 10px;
        }

        .question p {
          font-size: 14px;
          margin: 0;
        }

        .options {
          margin-left: 20px;
        }

        .options p {
          font-size: 14px;
          margin: 2px 0;
        }

        .page-break {
          page-break-before: always; /* Fuerza un salto de página antes de cada sección si se aplica */
        }
      </style>
    </head>
    <body>
      <div style="display: flex; justify-content: space-between">
        <div>
          <img src="https://pnsnrqedwbrugrblbkxm.supabase.co/storage/v1/object/public/profile-images/logo.png" width="60px" height="60px" alt="logo"/>
        </div>
        <div class="header">
            <h1>Inventario WAIS (Alianza terapéutica)</h1>
            <p class="result">${result}</p>
            <p style="margin: 0;">Fecha del cuestionario: ${date}</p>
        </div>
      </div>
      <div class="page">
        ${preguntasHTML}
      </div>
    </body>
    </html>
  `;
}

export const APPOINTMENTS_STATUS: any = {
  no_show: 'No asistio',
  canceled: 'Cancelada',
  done: 'Completada',
};

export const stripePlans = {
  hm_5: {
    monthly: 'price_1QRkzQIOKtPlJYpdz0nPAsTR',
    yearly: 'price_1QRknPIOKtPlJYpd4OOYj7Qe',
  },
  hm_10: {
    monthly: 'price_1QRkywIOKtPlJYpdl39n9kgX',
    yearly: 'price_1QRkokIOKtPlJYpd6pd6tEzj',
  },
  hm_20: {
    monthly: 'price_1QRkxzIOKtPlJYpdxk7I5xGv',
    yearly: 'price_1QRkpuIOKtPlJYpd0gHluhI3',
  },
  hm_25: {
    monthly: 'price_1QRkwyIOKtPlJYpd6KfEKgG0',
    yearly: 'price_1QRkr8IOKtPlJYpd78EzJaY3',
  },
  hm_30: {
    monthly: 'price_1QRkvoIOKtPlJYpdQLr2gNTx',
    yearly: 'price_1QRktKIOKtPlJYpdb4YeYa2E',
  },
};
